(() => {
  const KEY = 'liperla_wishlist_v2';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; }
  };
  const write = items => localStorage.setItem(KEY, JSON.stringify(items));
  const symbol = '<svg class="lpv2-dirham" viewBox="0 0 34 28" role="img" aria-label="UAE dirham"><path d="M8 3v22M8 4h8.5c6.4 0 10.5 3.8 10.5 10s-4.1 10-10.5 10H8M3 11h22M3 17h19"/></svg>';
  const cartIcon = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M4 6h3l3.1 14.2h13.7l3-10.2H9M12 26a1.7 1.7 0 1 1-3.4 0A1.7 1.7 0 0 1 12 26Zm13 0a1.7 1.7 0 1 1-3.4 0A1.7 1.7 0 0 1 25 26Z"/></svg>';
  const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
  const syncHearts = root => {
    const saved = read();
    (root || document).querySelectorAll('[data-lpv2-card]').forEach(card => {
      const active = saved.some(item => item.handle === card.dataset.productHandle);
      const button = card.querySelector('[data-lpv2-wishlist]');
      if (!button) return;
      button.classList.remove('is-active');
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + card.dataset.productTitle + (active ? ' from wishlist' : ' to wishlist'));
    });
  };
  const animateBadge = node => {
    node.classList.remove('is-bumping');
    void node.offsetWidth;
    node.classList.add('is-bumping');
  };
  const updateCartCount = cart => {
    const count = Number(cart.item_count || 0);
    document.querySelectorAll('.lp-cart').forEach(link => {
      let node = link.querySelector('.lp-cart__count');
      if (!node && count > 0) {
        node = document.createElement('span');
        node.className = 'lp-cart__count';
        link.appendChild(node);
      }
      if (node) {
        node.textContent = count;
        node.hidden = count < 1;
        animateBadge(node);
      }
      link.setAttribute('aria-label', 'Cart with ' + count + ' items');
    });
    document.querySelectorAll('[data-lp-cart-count],.lp-cart-count,.lp-cart__count,.cart-bubble__text-count,[data-cart-count]').forEach(node => {
      node.textContent = count;
      node.hidden = count < 1;
      node.classList.toggle('hidden', count < 1);
    });
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, source: 'liperla-card-v3' } }));
  };
  const updateWishlistCount = (animate = false) => {
    const count = read().length;
    document.querySelectorAll('a[href="/pages/wishlist"]').forEach(link => {
      link.classList.add('lp-wishlist');
      let badge = link.querySelector('.lp-wishlist__count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'lp-wishlist__count';
        link.appendChild(badge);
      }
      badge.textContent = count;
      badge.hidden = count < 1;
      link.setAttribute('aria-label', 'Wishlist with ' + count + ' items');
      if (animate && count > 0) animateBadge(badge);
    });
  };
  const refreshAndOpenDrawer = async () => {
    try {
      const response = await fetch('/?section_id=cart-drawer-section', { headers: { Accept: 'text/html' } });
      if (response.ok) {
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('#shopify-section-cart-drawer-section');
        const current = document.querySelector('#shopify-section-cart-drawer-section');
        if (next && current) current.innerHTML = next.innerHTML;
      }
    } catch (_) {}
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    if (window.customElements) await customElements.whenDefined('theme-drawer');
    if (typeof drawer.open === 'function') drawer.open();
    else {
      const panel = drawer.querySelector('dialog');
      drawer.setAttribute('open', '');
      if (panel && !panel.open) {
        try { panel.showModal(); } catch (_) { panel.setAttribute('open', ''); }
      }
    }
  };
  const addToCart = async form => {
    const button = form.querySelector('button');
    const label = button.querySelector('span');
    const original = label.textContent;
    button.disabled = true;
    label.textContent = 'Adding…';
    try {
      const response = await fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add product');
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(result => result.json());
      updateCartCount(cart);
      await refreshAndOpenDrawer();
      button.classList.add('is-added');
      label.textContent = 'Added';
      window.setTimeout(() => { button.classList.remove('is-added'); label.textContent = original; button.disabled = false; }, 1400);
    } catch (_) {
      label.textContent = 'Try again';
      window.setTimeout(() => { label.textContent = original; button.disabled = false; }, 1800);
    }
  };
  const renderWishlist = () => {
    if (!/^\/pages\/wishlist\/?$/.test(location.pathname)) return;
    const main = document.querySelector('#MainContent');
    if (!main || main.dataset.lpv2WishlistReady) return;
    main.dataset.lpv2WishlistReady = 'true';
    const items = read();
    const cards = items.map(item => {
      const discount = Number(item.discount || 0);
      const compare = discount > 0 ? '<s class="lpv2-card__compare-price">' + symbol + '<span>' + escapeHtml(item.comparePrice) + '</span></s><span class="lpv2-card__discount">' + discount + '% off</span>' : '';
      return '<article class="lpv2-card" data-lpv2-card data-product-handle="' + escapeHtml(item.handle) + '" data-product-title="' + escapeHtml(item.title) + '" data-product-url="' + escapeHtml(item.url) + '" data-product-image="' + escapeHtml(item.image) + '" data-variant-id="' + escapeHtml(item.variantId) + '" data-price="' + escapeHtml(item.price) + '" data-compare-price="' + escapeHtml(item.comparePrice) + '" data-discount="' + discount + '"><div class="lpv2-card__media"><a class="lpv2-card__image-link" href="' + escapeHtml(item.url) + '"><img class="lpv2-card__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '"></a><button class="lpv2-card__heart is-active" type="button" data-lpv2-wishlist aria-pressed="true" aria-label="Remove from wishlist"><svg viewBox="0 0 32 29" aria-hidden="true"><path d="M16 26.3 3.9 15.1C-3.4 8.3 6.9-2.1 14.3 4.4L16 6l1.7-1.6c7.4-6.5 17.7 3.9 10.4 10.7L16 26.3Z"/></svg></button></div><div class="lpv2-card__details"><a class="lpv2-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a><div class="lpv2-card__prices' + (discount ? '' : ' lpv2-card__prices--regular') + '"><strong class="lpv2-card__sale-price">' + symbol + '<span>' + escapeHtml(item.price) + '</span></strong>' + compare + '</div><form class="lpv2-card__form" method="post" action="/cart/add" data-lpv2-cart-form><input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '"><input type="hidden" name="quantity" value="1"><button type="submit">' + cartIcon + '<span>Add to cart</span></button></form></div></article>';
    }).join('');
    main.innerHTML = '<section class="lpv2-wishlist"><div class="lpv2-wishlist__head"><h1>My Wishlist</h1><p>Your saved LipErla fragrances.</p></div>' + (cards ? '<div class="lpv2-wishlist__grid">' + cards + '</div>' : '<div class="lpv2-wishlist__empty"><h2>Your wishlist is empty</h2><p>Tap the heart on any product to save it here.</p></div>') + '</section>';
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-lpv2-wishlist]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const card = button.closest('[data-lpv2-card]');
    if (!card) return;
    let items = read();
    const handle = card.dataset.productHandle;
    const existing = items.findIndex(item => item.handle === handle);
    if (existing >= 0) items.splice(existing, 1);
    else items.push({ handle, title: card.dataset.productTitle, url: card.dataset.productUrl, image: card.dataset.productImage, variantId: card.dataset.variantId, price: card.dataset.price, comparePrice: card.dataset.comparePrice, discount: card.dataset.discount });
    write(items);
    updateWishlistCount(true);
    if (/^\/pages\/wishlist\/?$/.test(location.pathname)) {
      document.querySelector('#MainContent').dataset.lpv2WishlistReady = '';
      renderWishlist();
    } else {
      syncHearts(document);
      button.classList.add('is-active');
      window.setTimeout(() => button.classList.remove('is-active'), 650);
    }
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-lpv2-cart-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });
  const init = root => { syncHearts(root || document); updateWishlistCount(false); };
  const boot = () => {
    renderWishlist();
    init(document);
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(response => response.json()).then(updateCartCount).catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-lpv2-card]') || node.querySelector?.('[data-lpv2-card]'))))) init(document);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();